import { StoryElementType } from 'webapp/enums/enums';

import StoryElementBase from 'webapp/models-custom/story-element/base';

export default class StoryElementValue extends StoryElementBase {
	type = StoryElementType.VALUE;
	longTitle = 'Value';

	override get isLoading(): boolean {
		return super.isLoading || !this.dataRoot;
	}

	openEdit(_node: HTMLElement): void {
		this.openAdvanced();
	}

	fillElementContent(node: HTMLElement): void {
		node.classList.toggle('loading', this.isDataIncomplete);

		const text = this.dataPoint?.valueStr || '-';
		node.textContent = text;
	}
}
